export function normalizePublicLandingUrl(value: unknown): string | null {
  if (typeof value !== 'string') return null;

  const trimmed = value.trim();
  // Same-scheme URLs without // resolve relative to the current page in an anchor.
  // Preserve accepted signed URL bytes, but reject browser-rewritten spellings.
  if (!/^https?:\/\//i.test(trimmed) || Array.from(trimmed).some(character => (
    character === '\\' || character.charCodeAt(0) < 0x20 || character.charCodeAt(0) === 0x7f
  ))) return null;

  try {
    const url = new URL(trimmed);
    return (url.protocol === 'http:' || url.protocol === 'https:') && url.hostname ? trimmed : null;
  } catch {
    return null;
  }
}
